export default __webpack_public_path__ + "static/bratz-x-bb-desktop-fee325134f2921dcf621f645592b9779.webp";